import { render, staticRenderFns } from "./main-inquiry.vue?vue&type=template&id=4a85e3e0&scoped=true&"
import script from "./main-inquiry.vue?vue&type=script&lang=js&"
export * from "./main-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./main-inquiry.vue?vue&type=style&index=0&id=4a85e3e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a85e3e0",
  null
  
)

export default component.exports